export default "__VITE_ASSET__DNOGUefl__"